import apiPlugin from "./apiPlugin";
import { ApiResponse } from "./../common/interfaces";
import CountryModel from "../models/Country/CountryModel";

export async function GetAllCountries(): Promise<ApiResponse<CountryModel[]>> {
	return apiPlugin<CountryModel[]>("GET", "GetAllCountries");
}

export async function AddUpdateCountryDetail(
	countryDetail: CountryModel
): Promise<ApiResponse<CountryModel>> {
	return apiPlugin<CountryModel>(
		"POST",
		"AddUpdateCountryDetail",
		undefined,
		countryDetail
	);
}

export async function DeleteCountryAsync(
	rowKey: string
): Promise<ApiResponse<boolean>> {
	return apiPlugin<undefined>(
		"DELETE",
		"DeleteCountryAsync",
		new URLSearchParams({
			rowKey,
		}),
		undefined,
		true
	);
}

export async function GetMyCountries(): Promise<ApiResponse<CountryModel[]>> {
	return apiPlugin<CountryModel[]>("GET", "GetMyCountries");
}

export async function GetAllAccessibleCountries(): Promise<
	ApiResponse<CountryModel[]>
> {
	return apiPlugin<CountryModel[]>("GET", "GetAllAccessibleCountries");
}
